<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <!-- タイトル -->
        <div class="text-center">
            <h3>{{ $t('hec.paymentsRenewal.title') }}</h3>
        </div>
        <!-- 送付数量 -->
        <div class="text-center text-quantitysent">
            <h4>{{ $t('hec.paymentsRenewal.quantitySent') }}</h4>
        </div>

        <div class="notes">
            <p class="text">
                <!-- メッセージ1 -->
                <span class="text-center" v-html="$t('hec.payments.message1')"></span><br/>
                <!-- メッセージ2 -->
                <span class="text-center" v-html="$t('hec.payments.message2')"></span><br/>
                <span></span><br/>
                <!-- メッセージ3 -->
                <span class="text-center" v-html="$t('hec.payments.message3')"></span><br/>
                <span></span><br/>
                <!-- メッセージ4 -->
                <span class="text-center" v-html="$t('hec.payments.message4')"></span><br/>
                <!-- メッセージ5 -->
                <span class="text-center" v-html="$t('hec.payments.message5')"></span><br/>
                <span></span><br/>
                <!-- メッセージ6 -->
                <span class="text-center" v-html="$t('hec.payments.message6')"></span><br/>
                <span></span><br/>
                <!-- メッセージ7 -->
                <span class="text-center" v-html="$t('hec.payments.message7')"></span><br/>
                <span></span><br/>
                <!-- メッセージ8 -->
                <span class="text-center" v-html="$t('hec.payments.message8')"></span><br/>
                <span></span><br/>
            </p>
        </div>

        <!-- オーダーIDボタン -->
        <div class="form-row py-3 justify-content-center">
            <div class="col-md-5">
                <router-link :to="{ name: 'MembershipFeeCompleteRenewal' }" class="text-center">
                    <span class="btn btn-primary btn-block">{{ $t('hec.paymentsRenewal.message9') }}</span>
                </router-link>
            </div>
        </div>

        <!-- 注意事項 -->
        <div class="notes">
            <p class="text">
                {{ $t('hec.paymentsRenewal.notes') }}<br/>
                {{ $t('hec.paymentsRenewal.notesMessage1') }}<br/>
                {{ $t('hec.paymentsRenewal.notesMessage2') }}
            </p>
        </div>

        <!-- キャンセルボタン -->
        <div class="form-row py-3 justify-content-center cancelbtn">
            <div class="col-md-4">
                <router-link :to="{ name: 'messages' }" class="text-center">
                    <span class="btn btn-light btn-block">{{ $t('hec.paymentsRenewal.cancelButton') }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
   
    export default {
        name: 'MembershipFeepaymentsRenewal',

        components: {
        },

        data() {
            return {

            }
        },

        async created() {
            
        },

        mounted() {
        },

        methods: {
        },
        computed: {
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .card-pricing .list-unstyled li {
        padding: .5rem 0;
        color: #6c757d;
    }
    .card-deck .card {
        flex: inherit;
    }
    .card-deck {
        padding: 0 0 0 10px;
    }
    .text-quantitysent {
        margin-top: 30px;
        margin-bottom: 20px;
    }        
    .text-message {
        margin-top: 20px;
    }
    .top {
        margin-top: 20px;
    }
    .text{
        margin-right: 10px;
    }
    .cancelbtn {
        margin-top: 20px !important;
    }
    .notes {
        margin: 16px auto;
        text-align: center;
        display: block;
    }
    .notes .text {
        text-align: left;
        display: inline-block;
    }
    .btn:hover {
        color: #fff !important;
    }
    @media screen and (max-width: 991px) {
        .attention >>> br {
            display: none;
        }
    }
</style>